var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgPersonalLike = function SvgPersonalLike(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: _id,
    x: 0,
    y: 0,
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "personalLike_svg__\\u63A7\\u4EF6",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "personalLike_svg__icon_\\u70B9\\u8D5E"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "personalLike_svg__mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#".concat(_id)
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "personalLike_svg__\\u77E9\\u5F62"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "personalLike_svg__icon_\\u70B9\\u8D5Esel",
    mask: "url(#personalLike_svg__mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 1.200000)",
    id: "personalLike_svg__\\u7F16\\u7EC4-27"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.53957575,0.823355308 L2.93003892,4.1114342 C2.82367207,4.24545433 2.66962363,4.32101432 2.50933773,4.32100603 L1.65520258,4.32100603 C0.735813322,4.32100603 0,5.08813233 0,6.02324118 L0,11.6485934 C0,12.5837023 0.735813322,13.3508286 1.65520258,13.3508286 L10.1827308,13.3508286 C11.2718465,13.3508286 12.1924334,12.5333081 12.3627988,11.4316255 L13.3132617,6.2908615 C13.3885996,5.80394418 13.2551061,5.30652414 12.9458746,4.92806159 L12.8358933,4.8060875 C12.5287145,4.49717367 12.1139783,4.32088715 11.6781961,4.32100605 L8.809,4.32005937 L9.30765141,3.05244159 C9.74307597,2.05475068 9.36309931,0.853439666 8.41653906,0.30522077 C7.45882655,-0.249513344 6.25689127,-0.0312955988 5.53957575,0.823355308 Z",
    id: "personalLike_svg__\\u8DEF\\u5F84",
    stroke: "#878D99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41,4.05112309 C2.68338095,4.05112309 2.91017619,4.25058024 2.95280143,4.51191023 L2.96,4.60112309 L2.96,8.57005937 C2.96,8.87381599 2.71375661,9.12005937 2.41,9.12005937 C2.13661905,9.12005937 1.90982381,8.92060223 1.86719857,8.65927223 L1.86,8.57005937 L1.86,4.60112309 C1.86,4.29736648 2.10624339,4.05112309 2.41,4.05112309 Z",
    id: "personalLike_svg__\\u8DEF\\u5F84",
    fill: "#878D99"
  }))))))));
};
export default SvgPersonalLike;